import type { ApiActionCallback, ApiDispatcherDispatchOptions } from '@app/packages/api/utils'

/**
 * A stub for an api action, or 'pass' to let the real call through. The action comes along so a
 * stub can answer about what was asked — `readApiRequest` turns it into the request it would have
 * sent, which is the only way to see an id the label does not carry.
 */
export type Interceptor = (input: {
  label: string
  action: ApiActionCallback<any>
  /** What the call would go out with, the session among them. */
  options: ApiDispatcherDispatchOptions
}) => (() => Promise<unknown>) | undefined | 'pass'

/**
 * The net polygons and tests hang in front of the api. An action is known by the label it was
 * created with, since that is all a caller has before the dispatcher builds the request.
 */
export class ApiInterceptor {
  interceptors: Interceptor[] = []

  intercept(interceptor: Interceptor) {
    this.interceptors.unshift(interceptor)
    return () => {
      this.interceptors = this.interceptors.filter(i => i !== interceptor)
    }
  }

  interceptApi<R>(label: string, stub: (action: ApiActionCallback<any>, options: ApiDispatcherDispatchOptions) => Promise<R>) {
    return this.intercept(input => (input.label === label ? () => stub(input.action, input.options) : undefined))
  }
}
